import { useTranslation } from 'react-i18next';
import { Wildfire } from 'features/wildfires/wildfire.types';
import { BroadcastifyFeeds } from 'features/broadcastify/components/BroadcastifyFeeds';
import { GeoEventLinks } from 'features/geoEvents/components/GeoEventLinks';
import { InitialLocationList } from 'features/geoEvents/components/InitialLocationList';
import { useReleaseFlag } from 'hooks/useReleaseFlags';
import { Link } from 'shared/types';
import { ProgressionModelsList } from '../ProgressionModelsList';
import { LinkTypes } from '../../../../constants';

type WildfireStructuredInfoProps = {
  wildfire: Wildfire;
};

export const WildfireStructuredInfo = (
  props: WildfireStructuredInfoProps,
): JSX.Element => {
  const { wildfire } = props;
  const { t } = useTranslation();
  const isInternalTabEnabled = useReleaseFlag('internal_tab_on_incidents');

  const internalLinks = wildfire.data?.internalLinks ?? [];

  const links: Link[] = wildfire.data?.links ?? [];
  const pulsepointLink: Link | null = wildfire.pulsepointReciprocalUrl
    ? {
        linkType: LinkTypes.website,
        label: t('geoEvent.structuredInfo.pulsepointLinkLabel', {
          name: wildfire.name,
        }),
        value: wildfire.pulsepointReciprocalUrl,
      }
    : null;
  const allLinks = pulsepointLink ? [...links, pulsepointLink] : links;

  return (
    <>
      {!isInternalTabEnabled && internalLinks.length > 0 && (
        <GeoEventLinks links={internalLinks} internal />
      )}
      {allLinks.length > 0 && <GeoEventLinks links={allLinks} />}
      <ProgressionModelsList wildfireId={wildfire.id} />
      <InitialLocationList
        coordinates={wildfire}
        paywallSource="wildfire_coordinates"
      />
      <BroadcastifyFeeds lat={wildfire.lat} lng={wildfire.lng} />
    </>
  );
};
